import { useCallback, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { api, ApiError } from "@/api/client";

export interface TriggerResult {
  task_id: string;
  status: string;
}

export function useOnboardingTrigger() {
  const [error, setError] = useState("");

  const mutation = useMutation({
    mutationFn: (projectSlug: string) =>
      api<TriggerResult>("/api/v2/onboarding/trigger", {
        method: "POST",
        body: JSON.stringify({ project_slug: projectSlug }),
      }),
  });

  const trigger = useCallback(
    async (projectSlug: string) => {
      setError("");
      try {
        return await mutation.mutateAsync(projectSlug);
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          setError("Project not found — it may have been removed.");
        } else {
          setError("Failed to trigger onboarding");
        }
        return null;
      }
    },
    [mutation],
  );

  return {
    trigger,
    result: mutation.data ?? null,
    loading: mutation.isPending,
    error,
  };
}
